import Vue from "vue"

import { format } from "date-fns"
import parseISO from "date-fns/parseISO"
import formatISO from "date-fns/formatISO"
import formatDistanceToNow from "date-fns/formatDistanceToNow"
import { it } from "date-fns/locale"

const DateFns = {
  install(Vue) {
    Vue.prototype.$formatDate = function (date, formatStr) {
      return format(date, formatStr, {
        locale: it,
      })
    }

    Vue.prototype.$parseDate = parseISO
    Vue.prototype.$formatDateISO = formatISO

    Vue.prototype.$timeAgo = function (date) {
      return formatDistanceToNow(date, { addSuffix: "fa", locale: it })
    }
  },
}

Vue.use(DateFns)

export default DateFns
